import performRequest from '@/utils/request';
import {
  endpoints,
  taskClaimEndpoint,
  taskEndpoint,
  taskManageEndpoint,
  taskRequestEndpoint, taskViewEndpoint,
} from '@/constants/urls';
import { transformForm } from '@/forms/state/state';
import { isEmpty } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';

const task = (code) => performRequest({
  url: taskEndpoint(code),
  method: 'GET',
});

const request = (code) => performRequest({
  url: taskRequestEndpoint(code),
  method: 'GET',
});

const claim = ({ code, assignee }) => performRequest({
  url: taskClaimEndpoint(code), data: { claim: isEmpty(assignee) }, method: 'POST',
});

const manage = ({ code, assignee, groups }) => performRequest({
  url: taskManageEndpoint(code),
  data: {
    assignee: assignee?.email || null,
    groups: groups.map((group) => group.code),
  },
  method: 'POST',
});

const update = ({ code, fields, completeStatus }) => performRequest({
  url: taskEndpoint(code),
  data: {
    complete: completeStatus === states.PENDING,
    fields: transformForm(fields),
  },
  method: 'PATCH',
});

const tasks = (filter, view, page, pageSize, orderBy) => {
  const params = { filter, page, pageSize };

  if (view) {
    params.query = view;
  }

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return (performRequest({ url: endpoints.REQUEST_TASKS, params, method: 'GET' }));
};

const view = (code) => performRequest({
  url: taskViewEndpoint(code),
  method: 'GET',
});

const views = (filter, page, pageSize, orderBy) => {
  const params = { filter, page, pageSize };

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return (performRequest({ url: endpoints.REQUEST_TASK_VIEWS, params, method: 'GET' }));
};

const RequestTasksService = {
  claim,
  manage,
  request,
  task,
  tasks,
  update,
  view,
  views,
};

export default RequestTasksService;
